export default __webpack_public_path__ + "images/no-image.svg?2f8dd4286fb9a8bd9a1ef78ffbc4aa2e";